
import { Link } from "react-router-dom";
import { UserCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

interface PuttingHeaderProps {
  username: string | null;
}

const PuttingHeader = ({ username }: PuttingHeaderProps) => {
  const { t } = useTranslation('training');
  
  return (
    <div className="flex justify-between mb-4">
      <div className="text-golf-600">
        <Link to="/" className="flex items-center gap-2 hover:text-golf-700">
          <UserCircle className="h-6 w-6" />
          {username && (
            <span>{t('putting.backToDashboard')}</span>
          )}
        </Link>
      </div>
    </div>
  );
};

export default PuttingHeader;
